import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { CODE_PR_DEL, CODE_PR_DET, CODE_PR_LIST, CODE_PR_SAVE } from "./action-types";

// List des projets
export function getCodeProjects() {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/projects`;
        let datas = [];

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CODE_PR_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("coprli004");
                dispatch({
                    type: CODE_PR_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Détail d'un projet
export function getCodeProject({idProject}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/project/${idProject}`;
        let datas = null;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CODE_PR_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("coprdt004");
                dispatch({
                    type: CODE_PR_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Save d'un projet
export function codeProjectSave({
    idProject = null,
    name
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/projects/save`;
        if (idProject != null) {
            url += `/${idProject}`;
        }
        let isNext = false;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            name: name
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CODE_PR_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("coprsa004");
                dispatch({
                    type: CODE_PR_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Suppression d'un projet
export function codeProjectDelete({
    idProject
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/code/projects/delete/${idProject}`;
        let isNext = false;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (alert.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CODE_PR_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("coprdl004");
                dispatch({
                    type: CODE_PR_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}